import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { DirectionsCar } from '@styled-icons/material-outlined/DirectionsCar';
import { useTrackElementClick } from '@utils/Tracking/ElementClick/TrackElementClick';
import * as S from './RegisteredVehicle.styles';

export interface RegisteredVehicleProps {
  plateNumber: string;
  manufactureName?: string;
  modelName?: string;
  onVehicleClick?: () => string | undefined;
}

export const RegisteredVehicle = ({
  plateNumber,
  manufactureName,
  modelName,
  onVehicleClick,
}: RegisteredVehicleProps) => {
  const fullName = `${manufactureName} ${modelName}`;
  const displayName = fullName.length > 18 ? `${fullName.slice(0, 18)}…` : fullName;
  const trackElementClick = useTrackElementClick();

  const handleClick = () => {
    const bookingUrl = onVehicleClick?.();
    trackElementClick({ elementType: 'card', linkText: displayName, linkUrl: bookingUrl });
  };

  return (
    <S.VehicleBoxWrapper onClick={handleClick}>
      <S.InnerWrapper>
        <S.LineSeparator />
        <S.VehicleBoxContent>
          <S.ContentContainer>
            <S.HoverWrap>
              <Text tag="span" variant={TextVariant.Header3}>
                {displayName}
              </Text>
            </S.HoverWrap>
            <S.InfoContainer>
              <DirectionsCar size={24} />
              <Text tag="span" variant={TextVariant.ArticleText}>
                {plateNumber}
              </Text>
            </S.InfoContainer>
          </S.ContentContainer>
        </S.VehicleBoxContent>
      </S.InnerWrapper>
    </S.VehicleBoxWrapper>
  );
};
